
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SLA',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/SLA.vue